/**
 * 加法
 * @param arg1
 * @param arg2
 * @returns
 */
export const accAdd = (arg1, arg2) => {
  let r1;
  let r2;
  let m;
  try {
    r1 = arg1.toString().split('.')[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split('.')[1].length;
  } catch (e) {
    r2 = 0;
  }
  m = Math.pow(10, Math.max(r1, r2));
  return (arg1 * m + arg2 * m) / m;
};

/**
 * 减法
 * @param arg1
 * @param arg2
 * @returns
 */
export const accSubtr = (arg1, arg2) => {
  let r1;
  let r2;
  let m;
  let n;
  try {
    r1 = arg1.toString().split('.')[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split('.')[1].length;
  } catch (e) {
    r2 = 0;
  }
  m = Math.pow(10, Math.max(r1, r2));
  // 动态控制精度长度
  n = r1 >= r2 ? r1 : r2;
  return ((arg1 * m - arg2 * m) / m).toFixed(n);
};

/***
 * 乘法，获取精确乘法的结果值
 * @param arg1
 * @param arg2
 * @returns
 */
export const accMul = (arg1, arg2) => {
  let m = 0;
  let s1 = (arg1 || 0).toString();
  let s2 = (arg2 || 0).toString();
  try {
    m += s1.split('.')[1].length;
  } catch (e) {}
  try {
    m += s2.split('.')[1].length;
  } catch (e) {}
  return (Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) / Math.pow(10, m);
};

/***
 * 除法，获取精确乘法的结果值
 * @param arg1
 * @param arg2
 * @returns
 */
export const accDivCoupon = (arg1, arg2) => {
  let t1 = 0;
  let t2 = 0;
  let r1;
  let r2;
  try {
    t1 = arg1.toString().split('.')[1].length;
  } catch (e) {}
  try {
    t2 = arg2.toString().split('.')[1].length;
  } catch (e) {}
  r1 = Number((arg1 || 0).toString().replace('.', ''));
  r2 = Number((arg2 || 0).toString().replace('.', ''));
  return (r1 / r2) * Math.pow(10, t2 - t1);
};

/***
 * 获取URl地址上的参数
 * @param queryName
 * @returns
 */
export const queryEle = (queryName) => {
  let reg = new RegExp('(^|&)' + queryName + '=([^&]*)(&|$)', 'i');
  let r = window.location.search.substr(1).match(reg);
  if (r !== null) {
    return decodeURI(r[2]);
  } else {
    return null;
  }
};

// 是否是企业微信环境
export const isWxBrowserForPC = () => {
  let userAgent = navigator.userAgent;
  return userAgent.includes('wxwork') && userAgent.toLowerCase().includes('micromessenger');
};

// 入口是PC端还是APP端
export const isPhoneBrowser = () => {
  let userAgent = navigator.userAgent;
  // 判断当前入口是PC端还是APP端
  let flag = userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i,
  );
  return flag !== null;
};

// 是否是本地运行
export const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.1/8 is considered localhost for IPv4.
    window.location.hostname.match(/^172(?:\.(?:2[0-5][0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/),
);
